import Swiper from 'swiper/swiper-bundle';

export function teamSlider() {
  const teamSwiper = new Swiper('.section-team__swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      550: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
}


// WEBPACK FOOTER //
// app/scripts/components/sliders/slider-team.js